import { format } from "date-fns";

export type DateOnlyInput = Date | string | null | undefined;

export function toDateOnlyString(value: DateOnlyInput): string | undefined {
  if (!value) return undefined;
  if (value instanceof Date) {
    return format(value, "yyyy-MM-dd");
  }
  return value;
}